import { render, staticRenderFns } from "./MCalendar.vue?vue&type=template&id=56cb3d4b&scoped=true&"
import script from "./MCalendar.vue?vue&type=script&lang=js&"
export * from "./MCalendar.vue?vue&type=script&lang=js&"
import style0 from "./MCalendar.vue?vue&type=style&index=0&id=56cb3d4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb3d4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56cb3d4b')) {
      api.createRecord('56cb3d4b', component.options)
    } else {
      api.reload('56cb3d4b', component.options)
    }
    module.hot.accept("./MCalendar.vue?vue&type=template&id=56cb3d4b&scoped=true&", function () {
      api.rerender('56cb3d4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MCalendar.vue"
export default component.exports